import type { FC } from "react";

import { Typography } from "@jti/ui";

import styles from "./AdditionalInfo.module.scss";

type AdditionalInfoProps = {
  additionalInfo: {
    title?: string;
    message?: string;
  };
};
export const AdditionalInfo: FC<AdditionalInfoProps> = ({ additionalInfo }) => {
  const { title, message } = additionalInfo || {};

  if (!title && !message) {
    return null;
  }

  return (
    <div className={styles.container} data-testid="additionalInfo">
      {title && <h4 className={styles.title}>{title}</h4>}
      {message && (
        <Typography variant="body1" weight="light" className={styles.text}>
          {message}
        </Typography>
      )}
    </div>
  );
};
